import { createInventoryItem } from "../../api/inventoryService";

export const useCreateInventoryItem = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createInventoryItem(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create inventory item:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};